import { withI18n } from '@lingui/react';
import React from 'react';
import { EditableMailOutBoundConfigProperty } from '../../../Atoms/EditableProperties/EditableMailOutBoundConfigProperty';
import { EditableAutocomplete } from '../../../Atoms/inputs/EditableAutocomplete';
import { HtmlFormatter } from '../../../Atoms/Formatter/HtmlFormatter';

export const MailAccountProviderSelection = withI18n()(({ i18n, mailOutBoundConfig, changeOutBoundConfig }) => {
  const providerOptions = [
    { provider: i18n._('settings.mail.provider.gmail') },
    { provider: i18n._('settings.mail.provider.gmx') },
    { provider: i18n._('settings.mail.provider.jimdo') },
    { provider: i18n._('settings.mail.provider.tonline') },
    { provider: i18n._('settings.mail.provider.yahoo') },
    { provider: i18n._('settings.mail.provider.allinkl') },
    { provider: i18n._('settings.mail.provider.1blu') },
    { provider: i18n._('settings.mail.provider.other') },
  ];

  if (!mailOutBoundConfig) {
    return null;
  }

  return (
    <EditableMailOutBoundConfigProperty
      entity={mailOutBoundConfig}
      patchField="provider"
      placeholder="E-Mail-Anbieter"
      suggestions={providerOptions}
      handleChange={(patch) =>
        changeOutBoundConfig({
          provider: patch.provider,
          defaultAccount: false,
        })
      }
      editFormatter={EditableAutocomplete}
      disableTextSelectionPopover
      labelFormatter={HtmlFormatter}
    />
  );
});
